"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomainDropdown = void 0;
const react_1 = __importStar(require("react"));
const polaris_1 = require("@shopify/polaris");
const client_1 = require("@apollo/client");
const styled_components_1 = __importDefault(require("styled-components"));
const AccountContext_1 = require("contexts/AccountContext");
const graphql_1 = require("components/Dashboard/TrackingPages/graphql");
const Container = styled_components_1.default.div `
  .Polaris-TextField__Prefix {
    margin-right: 0;
  }
`;
const DomainDropdown = (_a) => {
    var { error, label, onChange, onBlur, value } = _a, rest = __rest(_a, ["error", "label", "onChange", "onBlur", "value"]);
    const { account } = (0, AccountContext_1.useAccount)();
    const [selectedOption, setSelectedOption] = (0, react_1.useState)();
    const [inputValue, setInputValue] = (0, react_1.useState)(value);
    const [options, setOptions] = (0, react_1.useState)([]);
    const { loading, data: shopifyDomainsData } = (0, client_1.useQuery)(graphql_1.GET_SHOPIFY_DOMAINS, {
        skip: !account,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        variables: { input: { accountId: account.id } }
    });
    const domainOptions = (0, react_1.useMemo)(() => {
        if (!shopifyDomainsData) {
            return [];
        }
        const domains = shopifyDomainsData.shopifyGetDomains;
        return [
            { value: domains.domain, label: domains.domain },
            { value: domains.myshopifyDomain, label: domains.myshopifyDomain }
        ].filter((opt) => !!opt.value);
    }, [shopifyDomainsData]);
    (0, react_1.useEffect)(() => {
        setOptions(domainOptions);
        if (domainOptions.length > 1) {
            setSelectedOption(domainOptions[0].value);
            setInputValue(domainOptions[0].label);
        }
    }, [domainOptions]);
    (0, react_1.useEffect)(() => {
        onChange(inputValue);
    }, [inputValue]);
    const updateText = (0, react_1.useCallback)((val) => {
        setInputValue(val);
        if (val === '') {
            setOptions(domainOptions);
            return;
        }
        const filterRegex = new RegExp(val, 'i');
        const resultOptions = domainOptions.filter((option) => option.label.match(filterRegex));
        setOptions(resultOptions);
    }, [domainOptions]);
    const updateSelection = (0, react_1.useCallback)((selected) => {
        const matchedOption = options.find((option) => {
            return option.value.match(selected);
        });
        setSelectedOption(selected);
        setInputValue((matchedOption && matchedOption.label) || '');
    }, [options]);
    const optionsMarkup = options.length > 0
        ? options.map((option) => {
            return (react_1.default.createElement(polaris_1.Listbox.Option, { accessibilityLabel: option.label, key: `${option.value}`, selected: selectedOption === option.value, value: option.value }, option.label));
        })
        : null;
    return (react_1.default.createElement(Container, null,
        react_1.default.createElement(polaris_1.Combobox, { activator: react_1.default.createElement(polaris_1.Combobox.TextField, Object.assign({}, rest, { autoComplete: 'off', disabled: loading, error: loading ? undefined : error, label: label, onBlur: onBlur, onChange: updateText, placeholder: loading ? undefined : 'my-shopify-store.com', prefix: react_1.default.createElement("span", null, "https://"), value: inputValue })) }, options.length > 0 ? (react_1.default.createElement(polaris_1.Listbox, { onSelect: updateSelection }, optionsMarkup)) : null)));
};
exports.DomainDropdown = DomainDropdown;
